var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { CLASSNAME_PREFIX as cp } from './../../componentConfig';
import { H4 } from '@sitebase/ui-kit';
import './LiveChat.scss';
var LiveChat = (function (_super) {
    __extends(LiveChat, _super);
    function LiveChat(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isVisible: false,
        };
        _this.onClick = function () {
            try {
                var livePersonResponse = _this.lpClient.activateEngagement({ name: _this.lpEngagement });
                if (livePersonResponse instanceof Error) {
                    throw livePersonResponse;
                }
            }
            catch (error) {
                window.console.log(error);
                window.open(_this.fallbackUrl);
            }
        };
        _this.lpConfig = window.avAppConfig['live-person'];
        _this.lpClient = window.WH.LivePerson.createClient({ logger: console });
        _this.lpEngagement = _this.lpConfig.sdk.liveChatName;
        _this.fallbackUrl = window.avAppConfig.liveChatLink;
        return _this;
    }
    LiveChat.prototype.componentDidMount = function () {
        var _this = this;
        this.lpClient.init({
            sdk: this.lpConfig.sdk,
            cas: this.lpConfig.cas,
        });
        this.lpClient.onStateChange(function (state) {
            if (state.windowState === 'OPEN' || state.windowState === 'MINIMISED') {
                _this.setState({ isVisible: false });
            }
            else if (state.windowState !== 'UNKNOWN') {
                _this.setState({ isVisible: true });
            }
        });
        this.lpClient.onLiveChatReady(function (error, engagement) {
            if (error) {
                _this.setState({ isVisible: false });
            }
            else {
                _this.lpEngagement = engagement.name;
                _this.setState({ isVisible: true });
            }
        });
    };
    LiveChat.prototype.render = function () {
        var translate = this.props.t;
        var isVisible = this.state.isVisible;
        if (!isVisible) {
            return null;
        }
        return (React.createElement("div", { className: "".concat(cp, "-live-chat") },
            React.createElement("div", { className: "".concat(cp, "-live-chat__layout"), onClick: this.onClick },
                React.createElement("span", { className: "".concat(cp, "-live-chat__icon") }),
                React.createElement("div", null,
                    React.createElement(H4, null, translate('CHAT_LINK_TITLE_LINE_1')),
                    React.createElement("p", null, translate('CHAT_LINK_TITLE_LINE_2'))))));
    };
    return LiveChat;
}(React.Component));
export default LiveChat;
//# sourceMappingURL=LiveChat.js.map